import { useEffect, useMemo, useRef } from 'react'
import configment from '@adc/configment'
import { primitives, nudges } from '@adc/blueprint'

const useWebApplicationNudges = () => {
  const deviceStorageRef = useRef()

  useEffect(() => {
    deviceStorageRef.current = new primitives.DeviceStorageAdapter({
      storage: new primitives.WebLocalStorage({ namespace: 'nudges' }),
    })
  }, [])

  const config = useMemo(
    () => configment.get('NUDGE_RECURRENCE_DURATIONS', {}),
    []
  )
  return nudges.hooks.useApplicationNudges({
    config,
    deviceStorage: deviceStorageRef.current,
  })
}

export default useWebApplicationNudges
